import { GerberFilePreview } from "../../../common/ImageSetPreview";
import LoadingIcon from "../../../common/LoadingIcon";

import {
  Board,
  CADSources,
  PhysicalDetailsState,
} from "../../../../reducers/uploadedBoard";
import { useBoardFromContext } from "../../../../utils/hooks/commonly-stored/uploaded-board/board";
import Button from "../../../common/Button";
import { useState } from "react";
import Modal from "../../../common/Modal";
import ModalContentWithCloseButton from "../../../common/ModalContentWithCloseButton";
import EditFileMapping from "./EditFileMapping";
import { Container, NoLinks } from "./BoardPreviewStyles";
import { useAppSelector } from "../../../../utils/hooks/store";
import { useBoardImagesForSelectedSoldermask } from "../../../../utils/hooks/commonly-stored/uploaded-board/boardImages";
import ReprocessPhysicalDetails from "../../../internal/ReprocessPhysicalDetails";
import ReUploadGerbersForm from "../../../UploadBoard/ReUploadGerbersForm";
import UploadCustomerImageFiles from "../../../UploadBoard/AdditionalImageFilesUpload";
import { CustomerUploadedFiles } from "../../../ManufacturersPanel/AssemblyDrawings";

const BoardPreview = () => {
  const board = useBoardFromContext().board as Board;
  const [editFileMapping, setEditFileMapping] = useState(false);
  const [reuploadGerbers, setReuploadGerbers] = useState(false);
  const [moreAssemblyFiles, setMoreAssemblyFiles] = useState(false);
  const images = useBoardImagesForSelectedSoldermask(board);
  const isAdminOrEngineer = useAppSelector(
    (state) => state.auth.isAdminOrEngineer,
  );
  const closeUploadGerbersModal = () => setReuploadGerbers(false);
  const closeUploadMoreAssemblyFilesModal = () => setMoreAssemblyFiles(false);
  const closeFileMappingModal = () => setEditFileMapping(false);
  const waitingForPreviewFileGeneration =
    board.physical_details_state != PhysicalDetailsState.PROCESSED;
  if (images === null) {
    return <LoadingIcon text="Loading" />;
  }

  const noImages =
    images.top === null && images.bottom === null && images.layers.length == 0;

  if (!waitingForPreviewFileGeneration && noImages) {
    return (
      <>
        {isAdminOrEngineer && <ReprocessPhysicalDetails />}
        <NoLinks>Previews could not be generated</NoLinks>
      </>
    );
  }

  if (waitingForPreviewFileGeneration) {
    return (
      <Container>
        <LoadingIcon text="Generating previews" />
      </Container>
    );
  } else {
    return (
      <>
        {board.cad_source == CADSources.GERBER && (
          <>
            <Button
              label={"Change layer mappings"}
              onClick={() => setEditFileMapping(true)}
            />
          </>
        )}
        <Button
          label={"Replace gerber files"}
          onClick={() => setReuploadGerbers(true)}
        />
        <Button
          label={"Upload additional drawings / files"}
          onClick={() => setMoreAssemblyFiles(true)}
        />
        {isAdminOrEngineer && <ReprocessPhysicalDetails />}
        <CustomerUploadedFiles />
        <GerberFilePreview boardImages={images} />
        <Modal isOpen={editFileMapping} onRequestClose={closeFileMappingModal}>
          <ModalContentWithCloseButton
            title={"Update Gerber file mapping"}
            closeModal={closeFileMappingModal}
          >
            {board.cad_source === CADSources.GERBER && (
              <EditFileMapping onUpdate={closeFileMappingModal} />
            )}
          </ModalContentWithCloseButton>
        </Modal>
        <Modal
          isOpen={reuploadGerbers}
          onRequestClose={closeUploadGerbersModal}
        >
          <ModalContentWithCloseButton
            title={"Upload gerber files"}
            closeModal={closeUploadGerbersModal}
          >
            <ReUploadGerbersForm
              closeModal={closeUploadGerbersModal}
              boardId={board.id}
            />
          </ModalContentWithCloseButton>
        </Modal>
        <Modal
          isOpen={moreAssemblyFiles}
          onRequestClose={closeUploadMoreAssemblyFilesModal}
        >
          <ModalContentWithCloseButton
            title={"Upload image files"}
            closeModal={closeUploadMoreAssemblyFilesModal}
          >
            <UploadCustomerImageFiles
              closeModal={closeUploadMoreAssemblyFilesModal}
              boardId={board.id}
            />
          </ModalContentWithCloseButton>
        </Modal>
      </>
    );
  }
};

export default BoardPreview;
